import m from 'mithril'
import { apiBase } from '../api.ts'
import { devLogin, state } from '../state.ts'
import { ErrorNote } from '../ui.ts'

const PROVIDER_NAMES: Record<string, string> = { google: 'Google' }

// Google's four-colour "G", per their sign-in branding guidelines.
const GOOGLE_MARK = m('svg', { viewBox: '0 0 48 48', width: 18, height: 18, 'aria-hidden': 'true' }, [
  m('path', { fill: '#EA4335', d: 'M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z' }),
  m('path', { fill: '#4285F4', d: 'M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z' }),
  m('path', { fill: '#FBBC05', d: 'M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z' }),
  m('path', { fill: '#34A853', d: 'M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z' }),
])

export const Login: m.ClosureComponent = () => {
  let username = ''
  let error = ''
  let busy = false

  const submit = async (event: Event) => {
    event.preventDefault()
    busy = true
    try {
      await devLogin(username)
      error = ''
    } catch (err) {
      error = (err as Error).message
    } finally {
      busy = false
      m.redraw()
    }
  }

  return {
    view: () => {
      if (state.me) {
        return m('section.stack', [
          m('h1', `Signed in as ${state.me.displayName}`),
          m(m.route.Link, { href: `/u/${state.me.username}`, class: 'button primary' }, 'Your profile'),
        ])
      }

      return m('section.stack.narrow', [
        state.providers.length
          ? m(
              'div.stack',
              state.providers.map((provider) =>
                m(
                  'a.button.block.provider',
                  { href: `${apiBase}/api/auth/${provider}/start` },
                  [
                    provider === 'google' ? GOOGLE_MARK : null,
                    `Continue with ${PROVIDER_NAMES[provider] ?? provider}`,
                  ],
                ),
              ),
            )
          : null,
        state.devAuth
          ? m('form.card.stack', { onsubmit: submit }, [
              m('label', [
                'Username',
                m('input', {
                  value: username,
                  placeholder: 'sean',
                  autocapitalize: 'none',
                  oninput: (event: Event) => {
                    username = (event.target as HTMLInputElement).value
                  },
                }),
              ]),
              error ? m(ErrorNote, { text: error }) : null,
              m('button.button.primary', { type: 'submit', disabled: busy }, busy ? 'Signing in...' : 'Continue'),
            ])
          : null,
        !state.providers.length && !state.devAuth
          ? m(ErrorNote, { text: 'No sign-in method is configured on this server.' })
          : null,
      ])
    },
  }
}
